import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'nivelaciones-convenciones',
    standalone: false,
    templateUrl: 'nivelaciones-convenciones.component.html',
    styleUrls: ['nivelaciones-convenciones.component.scss']
})

export class NivelacionesConvencionesComponent implements OnInit {
    @Input()
    hijo?: boolean = false;
    @Input()
    completo?: boolean = false;
    @Input()
    direccion?: string = 'horizontal';
    @Input()
    asistencia?: boolean = false;
    @Input()
    data: any;
    @Input()
    dataFilterValues: string[];

    constructor() {
    }

    ngOnInit() {
    }
}
